"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    en: {
        ACCRE: {
            instruction: 'Print this document before taking a picture of it signed.',
            label: 'ACRE',
        },
        AUTHORIZATION_COMMUNICATE_THIRD_PARTIES: {
            label: 'Authorization to communicate to third parties',
        },
        BIKE_DELIVERY_STATEMENT: {
            instruction: 'Print or copy by hand this document before taking a picture of it filled, dated and signed.',
            label: 'Bike delivery statement',
        },
        CELIBACY_STATEMENT: {
            instruction: 'Print or copy by hand this document before taking a picture of it filled, dated and signed.',
            label: 'Declaration of single status',
        },
        CERTIFICATE_DELIVERY_INFORMATION_SPOUSE: {
            label: 'Certificate of delivery of the information to the spouse',
        },
        COMMERCIAL_LEASE: {
            label: 'Commercial lease',
        },
        COMPANY_CERTIFICATE_OF_RESIDENCE: {
            instruction: 'Take a picture or upload your company certificate of residence.',
            label: 'Company certificate of residence',
        },
        COMPENDIUM_OF_ASSENT: {
            label: 'Compendium of assent',
        },
        DIPLOMA_OR_PROOF_OF_EXPERIENCE: {
            label: 'Diploma or proof of experience of more than 3 years in the field of profession',
        },
        DRIVING_LICENSE_RECTO: {
            label: 'Driving license (recto)',
        },
        DRIVING_LICENSE_VERSO: {
            label: 'Driving license (verso)',
        },
        DRONE_PILOT_CERTIFICATE: {
            label: 'Drone pilot certificate',
        },
        ECSR_LICENSE_TITLE: {
            label: 'ECSR title',
        },
        GENERIC: {
            // Will be overriden by entity typeLocalized
            label: 'Other',
        },
        ID_RECTO_OWNER: {
            label: 'ID owner (recto)',
        },
        ID_VERSO_OWNER: {
            label: 'ID owner (verso)',
        },
        JPQA_FORM: {
            label: 'Professional Craftsmanship Qualification form',
        },
        NO_CRIMINAL_CONVICTION_STATEMENT: {
            instruction: 'Print or copy by hand this document before taking a picture of it filled, dated and signed.',
            label: 'No criminal conviction statement',
        },
        P0: {
            label: 'P0',
        },
        PACS_OR_MARRIAGE_CONTRACT_FAMILY_BOOK: {
            label: 'Pacs or marriage contract or family record book',
        },
        POWER_OF_ATTORNEY: {
            instruction: 'Print or copy by hand this document before taking a picture of it filled, dated and signed.',
            label: 'Power of attorney',
        },
        PROOF_OF_IDENTITY_HAND_WRITTEN: {
            instruction: 'Take a picture of an ID (ID front & back side or passport) + handwritten note like in the example',
            label: 'Proof of identity hand written',
        },
        PROOF_OF_RADIATION: {
            label: 'Proof of radiation (confirmation letter from URSSAF or the independants social security)',
        },
        PROOF_OF_REQUEST_ADDRESS_CHANGE: {
            label: 'Proof of request for change of address to the prefecture',
        },
        PROOF_PROVISION_OWNER: {
            label: 'Proof of provision owner',
        },
        PROOF_REGISTRATION_TRANSPORTATION_RENTAL: {
            label: 'Proof of registration transportation and rentals',
        },
        PROPERTY_TAX_RECTO: {
            label: 'Last property tax owner (recto)',
        },
        PROPERTY_TAX_VERSO: {
            label: 'Last property tax owner (verso)',
        },
        REQUEST_FOR_NON_ASSISTANCE: {
            label: 'Request for non-assistance',
        },
        VITALE_CARD: {
            label: 'Vitale Card',
        },
        VTC_CARD_RECTO: {
            label: 'VTC card (recto)',
        },
        VTC_CARD_VERSO: {
            label: 'VTC card (verso)',
        },
    },
    fr: {
        ACCRE: {
            instruction: "Imprimez le document ci-dessus puis prenez-le en photo après l'avoir signé.",
            label: 'ACRE',
        },
        AUTHORIZATION_COMMUNICATE_THIRD_PARTIES: {
            label: 'Autorisation de communiquer aux tiers',
        },
        BIKE_DELIVERY_STATEMENT: {
            instruction: 'Imprimez ou recopiez à la main le document ci-dessus puis prenez-le en photo, complété, daté et signé.',
            label: 'Déclaration de livraison à vélo',
        },
        CELIBACY_STATEMENT: {
            instruction: 'Imprimez ou recopiez à la main le document ci-dessus puis prenez-le en photo, complété, daté et signé.',
            label: 'Déclaration de célibat',
        },
        CERTIFICATE_DELIVERY_INFORMATION_SPOUSE: {
            label: 'Attestation de délivrance de l’information au conjoint',
        },
        COMMERCIAL_LEASE: {
            label: 'Bail commercial',
        },
        COMPANY_CERTIFICATE_OF_RESIDENCE: {
            instruction: 'Prenez en photo ou téléchargez votre attestation ou contrat de domiciliation.',
            label: 'Contrat de domiciliation',
        },
        COMPENDIUM_OF_ASSENT: {
            label: 'Recueil d’assentiment ',
        },
        DIPLOMA_OR_PROOF_OF_EXPERIENCE: {
            label: 'Diplôme ou justificatif d’expérience d’au moins 3 ans dans le domaine du métier exercé ',
        },
        DRIVING_LICENSE_RECTO: {
            label: 'Permis de conduire (recto)',
        },
        DRIVING_LICENSE_VERSO: {
            label: 'Permis de conduire (verso)',
        },
        DRONE_PILOT_CERTIFICATE: {
            label: 'Certificat théorique de télépilote de drone',
        },
        ECSR_LICENSE_TITLE: {
            label: 'ECSR - Titre Professionnel d’Enseignant de la Conduite et de la Sécurité Routière',
        },
        GENERIC: {
            // Will be overriden by entity typeLocalized
            label: 'Autre document',
        },
        ID_RECTO_OWNER: {
            label: 'Pièce d’identité du propriétaire (recto)',
        },
        ID_VERSO_OWNER: {
            label: 'Pièce d’identité du propriétaire (verso)',
        },
        JPQA_FORM: {
            label: 'Formulaire Justification de Qualification Professionnelle Artisanale',
        },
        NO_CRIMINAL_CONVICTION_STATEMENT: {
            instruction: 'Imprimez ou recopiez à la main le document ci-dessus puis prenez-le en photo, complété, daté et signé.',
            label: 'Déclaration de non-condamnation',
        },
        P0: {
            label: 'P0',
        },
        PACS_OR_MARRIAGE_CONTRACT_FAMILY_BOOK: {
            label: 'Contrat de PACS, de mariage, ou livret de famille',
        },
        POWER_OF_ATTORNEY: {
            instruction: 'Imprimez ou recopiez à la main le document ci-dessus puis prenez-le en photo, complété, daté et signé.',
            label: 'Pouvoir du mandataire',
        },
        PROOF_OF_IDENTITY_HAND_WRITTEN: {
            instruction: "prenez en photo une preuve d’identité (carte d'identité recto/verso ou passport) + mention écrite à la main comme sur le modèle ci-dessus",
            label: 'Preuve d‘identité manuscrite',
        },
        PROOF_OF_RADIATION: {
            label: 'Preuve radiation (lettre de confirmation de l’URSSAF ou de la sécurité sociale des indépendants)',
        },
        PROOF_OF_REQUEST_ADDRESS_CHANGE: {
            label: 'Justificatif de demande de changement d’adresse auprès de la préfecture',
        },
        PROOF_PROVISION_OWNER: {
            label: 'Attestation de mise à disposition par le propriétaire',
        },
        PROOF_REGISTRATION_TRANSPORTATION_RENTAL: {
            label: 'Attestation d’inscription au registre des transporteurs et des loueurs',
        },
        PROPERTY_TAX_RECTO: {
            label: 'Dernier avis de taxe foncière (recto)',
        },
        PROPERTY_TAX_VERSO: {
            label: 'Dernier avis de taxe foncière (verso)',
        },
        REQUEST_FOR_NON_ASSISTANCE: {
            label: 'Demande de non-assistance',
        },
        VITALE_CARD: {
            label: 'Carte vitale',
        },
        VTC_CARD_RECTO: {
            label: 'Carte VTC (recto)',
        },
        VTC_CARD_VERSO: {
            label: 'Carte VTC (verso)',
        },
    },
};
